import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TX from '@Components/Common/Text';
import { ContextMenu, Item } from '@Components/Common/ContextMenu';
import Checkbox from '@Components/Common/Checkbox';

// import { ReactComponent as PropertiesRequiredSVG } from '@Assets/Svgs/ic_properties_required.svg';
import { ReactComponent as PropertiesRequiredSVG } from '@Assets/Svgs/ic_required.svg';

import { ReactComponent as PropertiesShowSVG } from '@Assets/Svgs/ic_properties_show.svg';

import { ReactComponent as DonateSVG } from '@Assets/Svgs/ic_donate_king.svg';

const ChoiceShowMoreContextMenu = ({
  processId,
  choiceId,
  isShowChoiceVisibleCondition,
  isShowChoiceRequired,
  isShowChoiceRequiredSponsorCookie,
  handleAddChoiceVisibleConditionClick,
  handleAddChoiceRequiredClick,
  handleAddChoiceRequiredSponsorCookieClick,
  handleDuplicateChoiceClick,
  handleDeleteChoiceButtonClick,
  choices,
}) => {
  const moreThanFour = choices?.length >= 4;

  return (
    <ContextMenu position={{ top: 39, right: -7 }}>
      <Item onClick={handleAddChoiceVisibleConditionClick}>
        <ContextMenuItemText>
          <Checkbox
            id={`visible_condition_${processId}_${choiceId}`}
            isChecked={isShowChoiceVisibleCondition}
            label="선택지 노출 조건"
            Icon={PropertiesShowSVG}
          />
        </ContextMenuItemText>
      </Item>

      <Item onClick={handleAddChoiceRequiredClick}>
        <Checkbox
          id={`required_${processId}_${choiceId}`}
          isChecked={isShowChoiceRequired}
          label="선택지 활성 조건"
          Icon={PropertiesRequiredSVG}
          fill="#FC7248"
        />
      </Item>

      <Item onClick={handleAddChoiceRequiredSponsorCookieClick}>
        <Checkbox
          id={`requiredSponsorCookie${processId}_${choiceId}`}
          isChecked={isShowChoiceRequiredSponsorCookie}
          label="선택지 쿠키 조건"
          Icon={DonateSVG}
          fill="#FC7248"
        />
      </Item>

      {!moreThanFour && (
        <Item onClick={handleDuplicateChoiceClick}>
          <ContextMenuItemText>선택지 복제</ContextMenuItemText>
        </Item>
      )}

      <Item onClick={handleDeleteChoiceButtonClick}>
        <ContextMenuItemText isRed>선택지 삭제</ContextMenuItemText>
      </Item>
    </ContextMenu>
  );
};

ChoiceShowMoreContextMenu.propTypes = {
  processId: PropTypes.number.isRequired,
  choiceId: PropTypes.number.isRequired,
  isShowChoiceVisibleCondition: PropTypes.bool.isRequired,
  isShowChoiceRequired: PropTypes.bool.isRequired,
  handleAddChoiceVisibleConditionClick: PropTypes.func.isRequired,
  handleDuplicateChoiceClick: PropTypes.func.isRequired,
  handleDeleteChoiceButtonClick: PropTypes.func.isRequired,
};

const ContextMenuItemText = styled(TX.FootnoteM)`
  color: ${({ isRed, theme }) => (isRed ? theme.colors.danger : theme.colors.red)};
`;

export default ChoiceShowMoreContextMenu;
